import React from 'react';
import { format } from 'date-fns';

import { Stars } from '../../components/Stars/Stars';

import styles from '../../components/Feedback/Feedback.module.scss';

type FeedbackProps = {
  createdAt: string;
  author: string;
  comment: string;
  score: number;
};

export const Feedback: React.FC<FeedbackProps> = ({ createdAt, author, comment, score }) => {
  const assetPrefix = process.env.NEXT_PUBLIC_ASSET_PREFIX ?? '';
  const dateStart = format(new Date(createdAt.replace(/\s/, 'T')), 'd').toLocaleString();
  const dateEnd = format(new Date(createdAt.replace(/\s/, 'T')), 'MMMM yyyy').toLocaleString();
  const dateOrdinal = () => {
    const number = parseInt(dateStart);
    if (number > 3 && number < 21) return 'th';
    switch (number % 10) {
      case 1:
        return 'st';
      case 2:
        return 'nd';
      case 3:
        return 'rd';
      default:
        return 'th';
    }
  };
  const authorName = () => {
    return author.includes('DeletedFname') ? 'Hussle user' : author;
  };

  return (
    <div className={styles['feedback__item']}>
      <div className={styles['feedback__user']}>
        <img className={styles['feedback__user-img']} src={`${assetPrefix}/img/user.svg`} alt="User icon" />
        <div className="pull-left">
          <h4 className={styles['feedback__timestamp']}>
            {dateStart}
            <sup>{dateOrdinal()}</sup> {dateEnd}
          </h4>
          <h5 className={styles['feedback__name']}>
            {authorName()}
            <div className={styles['feedback__rating']}>
              <Stars color="secondary" value={score} />
            </div>
          </h5>
        </div>
      </div>
      <p className={styles['feedback__comment']}>{comment}</p>
    </div>
  );
};
